export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgQ3VzdG9tZXIgPSB7CiAgdXVpZDogc3RyaW5nOwogIG5hbWU6IHN0cmluZzsKfTsK"